import './fetefraiche/style';
import FormStructure from './fetefraiche/form_structure';

export default FormStructure;